import React from 'react';

const ModalActions = ({ onClose, children }) => {
  return (
    <div className="px-4 pb-5 pt-1 sm:px-6 flex flex-col-reverse sm:flex-row-reverse gap-2">
      <button
        type="button"
        className="ap-btn ap-btn-gray w-full sm:w-auto"
        onClick={onClose}
      >
        Cerrar
      </button>
      {children}
    </div>
  );
};

export default ModalActions;
